<template lang="html">
	<wizard-screen
		panelClass="omapi-panel__4"
		:completed="4"
		:total="5"
		:navPrev="false"
		:navNext="false"
	>
		<div class="omapi-screen-4">
			<h2>Included in Your Forever Free OptinMonster Account</h2>
			<core-alerts id="om-connect-errors" v-if="error" :alerts="alerts"></core-alerts>

			<common-selectable-input
				type="checkbox"
				name="includedItems"
				checked
				disabled
				v-for="item in includedItems"
				:key="item"
				:value="item"
				:label="item"
			></common-selectable-input>

			<div class="omapi-screen-4__form">
				<div class="omapi-flex omapi-name-inputs">
					<label class="omapi-flex omapi-flex-col">
						<input
							ref="firstNameInput"
							type="text"
							required="required"
							name="first-name"
							class="omapi-input"
							placeholder="Your first name..."
							v-model="inputFirstName"
						/>
						<span>First name</span>
					</label>
					<label class="omapi-flex omapi-flex-col">
						<input
							ref="lastNameInput"
							type="text"
							required="required"
							name="last-name"
							class="omapi-input"
							placeholder="Your last name..."
							v-model="inputLastName"
						/>
						<span>Last name</span>
					</label>
				</div>

				<label style="margin-bottom: 13px;">
					<input
						ref="emailInput"
						type="email"
						required="required"
						name="email"
						class="omapi-input"
						placeholder="Your best email address..."
						v-model="inputEmail"
					/>
					<span>Your best email address</span>
				</label>

				<core-loading v-if="isLoading">
					<strong>Please wait...</strong>
				</core-loading>

				<wizard-next-link
					v-else
					class="omapi-button__large"
					text="Create Your Free Account Now"
				/>
			</div>

			<h3 class="omapi-screen-4__upsell-title">Plus All These Bonuses For FREE!...</h3>

			<div class="omapi-screen-4__upsell-wrap">
				<div class="omapi-screen-4__upsell-icon">
					<img
						src="../../assets/images/wizard/dfy.png"
						width="54"
						height="54"
						alt="Done-For-You Campaign Setup Service by OptinMonster"
					>
				</div>

				<div class="omapi-screen-4__upsell-description">
					<div><strong>Done-For-You Campaign Setup ($297 value)</strong></div>
					<div>Our conversion experts will design <strong>1</strong> free campaign for you to get maximum results.</div>
				</div>
			</div>

			<div class="omapi-screen-4__upsell-wrap">
				<div class="omapi-screen-4__upsell-icon">
					<img
						src="../../assets/images/wizard/resources-bundle.png"
						width="54"
						height="54"
						alt="OptinMonster University"
					>
				</div>

				<div class="omapi-screen-4__upsell-description">
					<div><strong>OptinMonster University ($1,997 value)</strong></div>
					<div>Instant access to our library of expert courses, guides, video training and ebooks.</div>
				</div>
			</div>

			<template v-if="showProUpsells">
				<div class="omapi-box__gray">
					<div>
						<h3>What happens if I exceed 500 campaign pageviews in a month?</h3>
						<div>First we celebrate! It’s always a good thing when more people see your offers. If your Forever Free account exceeds 500 campaign pageviews in a given month, you’ll be upgraded to the appropriate subscription based on the pageviews. This ensures your campaigns will never stop displaying.</div>
					</div>

					<div>
						<h3>What if I don’t want to be automatically upgraded?</h3>
						<div>No problem! You can control what happens if/when you exceed those pageviews directly within your Account Dashboard. And, we’ll always give you a heads up when you’re approaching your limits so you can confirm your preference.</div>
					</div>

					<div class="omapi-box__guarantee">
						<img
							src="../../assets/images/wizard/14dayguarantee.svg"
							width="100"
							height="100"
							alt="14 Days Unconditional Guarantee"
						>

						<div>
							<h3>Our Promise</h3>
							<div>If your account exceeds the impressions available to it and is automatically upgraded… but you decide you’d rather not upgrade, we’ll refund the full cost of that upgrade. Just ask within the first 14 days of the upgrade and we’ll take care of it right away.</div>
						</div>
					</div>
				</div>

				<div class="omapi-screen-4__testimonial">
					<img src="../../assets/images/welcome/rating.svg" alt="Five Stars">
					<span>"<strong>Instant 12% lift</strong> in driving sales." - Neil Patel</span>
					<img
						class="person"
						width="50"
						height="50"
						alt="Neil Patel knows tools like OptinMonster work for increasing subscribers and sales!"
						src="../../assets/images/wizard/neilpateltiny.jpg"
					>
				</div>

				<core-loading v-if="isLoading">
					<strong>Please wait...</strong>
				</core-loading>

				<wizard-next-link
					v-else
					class="omapi-button__large"
					text="Create Your Free Account Now"
				/>
			</template>
		</div>
	</wizard-screen>
</template>

<script lang="js">
import { getAppData } from '@/utils'
import { mapState, mapActions, mapGetters } from 'vuex'
import { screen } from './mixins/screen'

export default {
	mixins : [ screen ],

	data : () => ({
		inputFirstName : '',
		inputLastName  : '',
		inputEmail     : '',
	}),

	mounted () {
		if (this.userId) {
			return this.skip()
		}

		this.$store.commit('clearAlerts')
		window.addEventListener('message', this.listenMessage)

		this.preloadUser()

		// Use instead of $nextTick, or input doesn't get focused, ¯\_(ツ)_/¯
		setTimeout(() => {
			this.$refs.firstNameInput.focus()
		}, 50)
	},

	beforeDestroy () {
		window.removeEventListener('message', this.listenMessage)
	},

	computed : {
		...mapState([ 'error', 'alerts' ]),
		...mapGetters([ 'userEmail', 'userFirstName', 'userLastName', 'userId', 'showProUpsells' ]),
		...mapGetters('wp', [ 'isWooActive', 'isWooConnected' ]),
		isLoading () {
			return this.$store.getters.isLoading([ 'connect', 'wizard' ])
		},
		isDisabled () {
			return this.isLoading || !this.$store.state.apiKey
		},
		includedItems () {
			return [
				'2 campaigns and up to 500 campaign impressions/month',
				'Page targeting to show campaigns only on specific pages',
				'Lead storage to save your leads’ name and email addresses',
				'Easy to understand reporting',
				'35% discount on upgrades to OptinMonster Pro',
				'And much more!',
			]
		},
	},

	methods : {
		...mapActions([ 'saveApiKey' ]),
		listenMessage (evt) {
			const { origin, data } = evt
			if (origin.replace(/\/$/, '') !== this.$urls.app().replace(/\/$/, '')) {
				return
			}

			if (!data || 'string' !== typeof data) {
				return
			}

			try {
				// Get passed status.
				const data = JSON.parse(evt.data)

				if (!data.omWizard) {
					throw new Error('no')
				}

				// Do action based on status.
				switch (data.status) {
				case 'loaded':
					this.onCheckoutLoaded(data)
					break
				case 'registered':
					this.onCheckoutRegistered(data.apiKey)
					break
				case 'complete':
					window.location.reload()
					break
				default:
				}
			} catch (e) {

			}
		},
		openCheckoutWindow () {
			if (this.childWindowOpened) {
				return
			}

			let url = this.$urls.app('checkout/wp-plugin/')
			const partnerUrl = getAppData('partnerUrl')
			if (partnerUrl) {
				const urlObj = new URL(partnerUrl)
				urlObj.searchParams.set('urllink', url)
				url = urlObj.toString()
			}

			this.childWindow = window.open(
				url,
				'_blank',
				'width=700,height=700,left=200,top=100'
			)
			this.childWindowOpened = true
		},
		onCheckoutLoaded (data) {
			const payload = {
				omWizard  : true,
				status    : 'loaded',
				origin    : window.location.protocol + '//' + window.location.host,
				siteName  : getAppData('blogname'),
				partnerId : getAppData('partnerId'),
				user      : {
					email     : this.inputEmail.trim(),
					firstName : this.inputFirstName.trim(),
					lastName  : this.inputLastName.trim(),
				},
				onboarding : {
					via                      : 'wordpress',
					woocommerce_active       : this.isWooActive,
					woocommerce_connected    : this.isWooConnected,
					usage                    : this.onboardingUsage,
					usage_other_text         : this.onboardingUsageOtherText,
					email_list               : this.onboardingEmailList,
					email_service            : this.onboardingEmailService,
					email_service_other_text : this.onboardingEmailServiceOtherText,
					goal                     : this.onboardingGoal,
					extra_features           : this.extraFeatures,
				},
			}

			this.childWindow.postMessage(JSON.stringify(payload), this.$urls.app())
		},
		onCheckoutRegistered (apiKey) {
			const done = () => {
				this.$store.commit('loading', 'wizard')

				window.location.reload()
			}
			this.saveApiKey(apiKey)
				.then(done)
				.catch(() => {
					// TODO Handle failures here.
					// What happens with user, etc? How can they proceed?
					done()
				})
		},
		preloadUser () {
			this.inputEmail = (this.userEmail || '').trim()
			this.inputFirstName = (this.userFirstName || '').trim()
			this.inputLastName = (this.userLastName || '').trim()
		},
		inputsValidated () {
			if (!this.inputFirstName.trim()) {
				this.$refs.firstNameInput.focus()
				return false
			}

			if (!this.inputLastName.trim()) {
				this.$refs.lastNameInput.focus()
				return false
			}

			if (!this.inputEmail.trim()) {
				this.$refs.emailInput.focus()
				return false
			}

			return true
		},

		canNextPage (proceed) {
			proceed.canProceed = false
			if (!this.isLoading && this.inputsValidated()) {
				this.openCheckoutWindow()
			}
		},
	},
}
</script>

<style scoped lang="scss">
	.omapi-screen .omapi-panel__4 {
		.omapi-wizard-forward {
			border-radius: 3px;
			font-size: 16px;
			margin: 0 0 40px;
			padding: 16px 60px;
		}
		.om-circle-loading {
			margin: 0 0 20px;
		}

		.omapi-button__large {
			margin-bottom: 33px !important;
		}
	}
</style>
